<template>
  <v-layout row>
    <v-flex
      xs12
      sm8
      offset-sm2
      md6
      offset-md3
      lg6
      offset-lg3
      xl6
      offset-xl3
    >
      <div class="register">
        {{ $t('no_account') }} <router-link :to="{ name: 'register' }">{{ $t('sign_up') }}</router-link>
      </div>
      <v-divider class="mt-2 mb-2" />
      <div class="text-xs-center">
        {{ $t('sign_up_social') }}
      </div>
<!--      <div class="social ma-3">-->
<!--        <login-with-social-->
<!--          provider="facebook"-->
<!--          :url="url.facebook"-->
<!--        />-->
<!--      </div>-->
      <div class="social ma-3">
        <login-with-social
          provider="google"
          :url="url.google"
        />
      </div>
      <v-divider class="mt-4 mb-3" />
      <div class="text-xs-center">
        {{ $t('sign_up_email') }}
      </div>
      <v-card
        flat
        :color="theme.login_bg_color"
      >
        <progress-bar :show="busy"></progress-bar>
        <form
          @submit.prevent="login"
          @keydown="form.onKeydown($event)"
        >
          <v-card-text>
            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              prepend="person_outline"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :v-errors="errors"
              :form="form"
              :label="$t('password')"
              :value.sync="form.password"
              prepend="lock_outline"
              v-validate="'required|min:6'"
            ></password-input>

            <hidden-input
              name="loyalty_group_id"
              :value="form.loyalty_group_id"
            ></hidden-input>

            <submit-button
              block
              :form="form"
              dark
              :color="theme.btn_color_primary"
              :label="$t('sign_in')"
            ></submit-button>
          </v-card-text>
        </form>
      </v-card>
      <div class="forget">
        <router-link :to="{ name: 'password.request' }">{{ $t('forgot_password') }}</router-link>
      </div>
      <div
        class="home"
        v-if="allowCheckout.guest"
      >
        <router-link :to="{ name: 'welcome' }">{{ $t('continue_as_guest') }}</router-link>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Form from 'vform'
import LoginWithSocial from '~/components/LoginWithSocial'

export default {
  name: 'login-view',
  layout: 'default',
  metaInfo () {
    return { title: this.$t('sign_in') }
  },
  components: {
    'login-with-social': LoginWithSocial
  },
  data: () => ({
    form: new Form({
      email: '',
      password: '',
      loyalty_group_id: '',
    }),
    eye: true,
    remember: true,
    busy: false,
    url: {
      facebook: '',
      google: ''
    }
  }),
  computed: {
    ...mapGetters('config', [
      'gid', 'loyaltyGroupId', 'theme', 'allowCheckout', 'mode'
    ]),
    ...mapGetters('member', [
      'isMember'
    ])
  },
  methods: {
    async login () {
      if (await this.formHasErrors()) return
      this.busy = true

      try {
        // Submit the form.
        const { data } = await this.form.post('/api/login')

        // Save the token.
        this.$store.dispatch('auth/saveToken', {
          token: data.token,
          remember: this.remember
        })

        await this.$store.dispatch('auth/fetchUser')
        await this.$store.dispatch('member/fetchProfile')

        if (this.isMember) {
          // Ensure we can really find this member from Loyalty db
          const result = await axios.post('/api/member/login', {
            loyalty_group_id: this.loyaltyGroupId
          })
          // Happens when restaurant's group id is manually changed in loyalty DB
          if (result.data === 0) {
            const result2 = await axios.post('/api/member/reset', {
              loyalty_group_id: this.loyaltyGroupId,
            })
            await this.$store.dispatch('auth/saveUser', result2.user)
            this.$store.dispatch('member/resetMemberData')
            this.$router.push({ name: 'register2' })
          } else {
            this.$store.dispatch('fetchMembershipInfo')
            this.$router.push({ name: 'home' })
          }
          this.busy = false
        } else {
          this.$router.push({ name: 'register2' })
        }
      } catch (e) {
        this.busy = false
      }
    },
    async callBackFromSocial (e) {
      if (e.origin !== window.origin || !e.data.token) {
        return
      }

      this.$store.dispatch('auth/saveToken', {
        token: e.data.token
      })

      await this.$store.dispatch('auth/fetchUser')
      await this.$store.dispatch('member/fetchProfile')

      if (this.isMember) {
        // Ensure we can really find this member from Loyalty db
        const result = await axios.post('/api/member/login', {
          loyalty_group_id: this.loyaltyGroupId
        })
        // Happens when restaurant's group id is manually changed in loyalty DB
        if (result.data === 0) {
          const result2 = await axios.post('/api/member/reset', {
            loyalty_group_id: this.loyaltyGroupId,
          })
          await this.$store.dispatch('auth/saveUser', result2.user)
          this.$store.dispatch('member/resetMemberData')
          this.$router.push({ name: 'register2' })
        } else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.$router.push({ name: 'register2' })
      }
    }
  },
  async beforeMount () {
    if (window.config.token) {
      this.$store.dispatch('auth/saveToken', {
        token: window.config.token
      })

      await this.$store.dispatch('auth/fetchUser')
      await this.$store.dispatch('member/fetchProfile')

      if (this.isMember) {
        // Ensure we can really find this member from Loyalty db
        const result = await axios.post('/api/member/login', {
          loyalty_group_id: this.loyaltyGroupId
        })
        // Happens when restaurant's group id is manually changed in loyalty DB
        if (result.data === 0) {
          const result2 = await axios.post('/api/member/reset', {
            loyalty_group_id: this.loyaltyGroupId,
          })
          await this.$store.dispatch('auth/saveUser', result2.user)
          this.$store.dispatch('member/resetMemberData')
          this.$router.push({ name: 'register2' })
        } else {
          this.$router.push({ name: 'home' })
        }
      } else {
        this.$router.push({ name: 'register2' })
      }
    }
    this.url.facebook = await this.$store.dispatch('auth/fetchOauthUrl', {
      provider: 'facebook'
    })
    this.url.google = await this.$store.dispatch('auth/fetchOauthUrl', {
      provider: 'google'
    })
    window.addEventListener('message', this.callBackFromSocial, false)
  },
  beforeDestroy () {
    window.removeEventListener('message', this.callBackFromSocial)
  },
  created () {
    this.form.loyalty_group_id = this.loyaltyGroupId;
  }
}
</script>

<style scoped>
.forget {
  text-align: center;
}
.register {
  font-weight: bolder;
  text-align: center;
  margin-top: 15px;
}
.home {
  text-align: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/login.vue